import styled from 'styled-components';
import { Button, Row } from '@snsw-gel/react';

export const StyledBackButton = styled(Button)`
  width: fit-content;
`;

export const StyledRow = styled(Row)`
  margin-top: 2.5rem;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ConsentSection = styled.section`
  margin-top: 1.5rem;
`;

export const FormSection = styled.section`
  margin-top: 1rem;
`;

export const ReviewValue = styled.p`
  margin: 0;
  line-height: 1.5rem;
`;

export const ReviewItem = styled.div`
  margin-bottom: 1rem;

  .HeadingStyle-root,
  h5 {
    margin-bottom: 0.25rem !important;
  }
`;
